module.exports = __webpack_public_path__ + "img/icon3.0ff70f03.png";